import { useSettings } from "../../context/SettingsProvider";
import { useUser } from "../../context/UserProvider";

export default function UserDetails(){
	const userContext = useUser();
	const settings = useSettings();
	
	return(
		<div className={settings.isLoading ? "comments--login is-loading" : "comments--login"}>
			{ (!settings.isCommentsOpen && !settings.isDisabledCommentsMessageHidden) &&
				<span>Comments to this post are closed.</span>
			}
			{ settings.isCommentsOpen && settings.commentRegistration && userContext.type !== "logged" &&
				<>
					<span>User must be registered to leave comments. </span>
					<a href={settings.urls.loginUrl}>Log In?</a>
				</>
			}
			{ settings.isCommentsOpen && userContext.name &&
				<>
					{userContext.type === "logged" &&
						<>
							<span>Logged in as <strong>{userContext.name}</strong>. </span>
							<a href={settings.urls.logoutUrl}>Log Out?</a>
						</>
					}
					{userContext.type === "commenter" && !settings.commentRegistration &&
						<span>You can leave comments as <strong>{userContext.name}</strong> now. </span>
					}
				</>
			}
		</div>
	)
}